import { useAppSelector } from "@hypexone/uicore";
import { domain } from "../../../constants/Branding";
import { getEnvVariable } from "../../../constants/brandConfig";
import AndroidIcon from "../../../assets/icons/android-icon.svg";

type DownloadApkButtonProps = {
  onDownload?: () => void;
  className?: string;
  variant?: "desktop" | "mobile";
};

const DownloadApkButton = ({
  onDownload,
  className,
  variant = "desktop",
}: DownloadApkButtonProps) => {
  const { domainConfig } = useAppSelector((state) => state.common);
  const { langData } = useAppSelector((state) => state.cms);
  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  const label = langData?.["download_apk"] || "Download APK";

  if (!apkUrl) return null;

  const handleDownload = () => {
    const href = apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
    const link = document.createElement("a");
    link.href = href;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    onDownload?.();
  };

  if (variant === "mobile") {
    return (
      <div
        className={[
          "flex items-center justify-between py-2 font-[900] text-[17.2px] border-b border-gray-200 hover:bg-gray-50 cursor-pointer text-[#2789ce]",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={handleDownload}
      >
        <span className="ml-4 text-[17px] font-[900] font-sans download-apk-text-blink">{label}</span>
      </div>
    );
  }

  return (
    <div
      className={[
        "hover:underline cursor-pointer border-b border-b-gray18",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="px-2 py-1 download-apk-text-blink" onClick={handleDownload}>
        {label}
      </div>
    </div>
  );
};

export default DownloadApkButton;
